/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, useCallback } from 'react';
import RequestList, { RequestListProps } from './RequestListDesktop';
import { TableManageRequestsActions } from '../tableActions';

export interface ManageRequestListProps
  extends Omit<RequestListProps, 'renderActionColumn'> {
  onImport?: (recordKey: string) => void;
  onExport?: (requestNo: string) => void;
  onView?: (recordKey: string) => void;
  onCancel?: (recordKey: string) => void;
  onDelete?: (requestNo: string) => void;
  onApprovalHistory?: (requestNo: string) => void;
  onCompare?: (requestNo: string) => void;
  showAction?: boolean;
  hidePagination?: boolean;
  isFiltersApplied?: boolean;
  isSearchApplied?: boolean;
}

const ManageRequestList: React.FC<ManageRequestListProps> = (
  props
): JSX.Element => {
  const {
    showAction = true,
    onImport,
    onExport,
    onView,
    onDelete,
    onCompare,
    hidePagination = false,
    isFiltersApplied = false,
    isSearchApplied = false,
    ...restProps
  } = props;

  const renderActionColumn = useCallback(
    (_text: any, record: any) => {
      return (
        <TableManageRequestsActions
          status={record.status}
          requestNo={record.key}
          onImport={() => onImport?.(record.bsReqId)}
          onExport={() => onExport?.(record.key)}
          onView={() => onView?.(record.key)}
          onDelete={() => onDelete?.(record.key)}
        />
      );
    },
    [onImport, onExport, onView, onDelete, onCompare]
  );

  return (
    <RequestList
      {...restProps}
      isFiltersApplied={isFiltersApplied}
      isSearchApplied={isSearchApplied}
      hidePagination={hidePagination}
      renderActionColumn={showAction ? renderActionColumn : undefined}
    />
  );
};

export default memo(ManageRequestList) as typeof ManageRequestList;
